import React, { FC } from 'react'

const BookMarkIcon: FC = () => (
  <svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.8005 -8.84355e-05C6.1315 -0.000531179 5.05211 -0.000817627 4.14597 0.293608C2.31934 0.887115 0.887237 2.31922 0.29373 4.14584C-0.000695556 5.05199 -0.000409108 6.13137 3.36348e-05 7.80038L6.86824e-05 20.9999C6.86824e-05 21.3905 0.227411 21.7453 0.582212 21.9085C0.937013 22.0716 1.35435 22.0134 1.65086 21.7592L3.44453 20.2218C4.37996 19.42 5.0397 18.8554 5.59342 18.4494C6.13703 18.0508 6.51963 17.8503 6.88139 17.745C7.61199 17.5321 8.38815 17.5321 9.11875 17.745C9.48051 17.8503 9.86311 18.0508 10.4067 18.4494C10.9604 18.8554 11.6202 19.42 12.5556 20.2218L14.3493 21.7592C14.6458 22.0134 15.0631 22.0716 15.4179 21.9085C15.7727 21.7453 16.0001 21.3905 16.0001 20.9999L16.0001 7.80038C16.0005 6.13138 16.0008 5.05199 15.7064 4.14584C15.1129 2.31922 13.6808 0.887115 11.8542 0.293608C10.948 -0.000817627 9.86864 -0.000531179 8.19964 -8.84355e-05H7.8005Z"
      fill="#7A7A7A"
    />
  </svg>
)

export default BookMarkIcon
